import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EventLocationComponent } from './event-location.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [EventLocationComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [EventLocationComponent]
})
export class EventLocationModule { }
